module.exports = __webpack_public_path__ + "img/NAsh_logo1.baddc6ae.png";